import BallColor from "../../items/BallColor";
import SpanCollor from '../../items/SpanCollor';

function CardProfile() {
    return (
        <div className='card-info'>
                <div className='header-card'>
                    <div className='items-balls'>
                        <BallColor color="pink"></BallColor>
                        <BallColor color="yellow"></BallColor>
                        <BallColor color="blue"></BallColor>
                        <BallColor color="green"></BallColor>
                    </div>
                    <SpanCollor color="silver">tiago_profile.py</SpanCollor>
                </div>

                <p className="item-class">
                    <SpanCollor color="pink">class </SpanCollor>
                    <SpanCollor color="yellow">Developer</SpanCollor>
                </p>

                <p className="item-def-1">
                    <SpanCollor color="pink">def </SpanCollor> 
                    <SpanCollor color="silver">__init__(self):</SpanCollor>
                </p>

                <p className="subitem-def-1">
                    <SpanCollor color="purple">self</SpanCollor>
                    <SpanCollor color="silver">.name =</SpanCollor>
                    <SpanCollor color="green"> Tiago Lucas</SpanCollor>
                </p>

                <p className="subitem-def-1">
                    <SpanCollor color="purple">self</SpanCollor>
                    <SpanCollor color="silver">.role =</SpanCollor>
                    <SpanCollor color="green"> "Full-Stack Dev"</SpanCollor>
                </p>

                <p className="subitem-def-1">
                    <SpanCollor color="purple">self</SpanCollor>
                    <SpanCollor color="silver">.location =</SpanCollor>
                    <SpanCollor color="green"> "Londrina, PR"</SpanCollor>
                </p>
                
                <p className="subitem-def-1">
                    <SpanCollor color="purple">self</SpanCollor>
                    <SpanCollor color="silver">.stack =</SpanCollor>
                    <SpanCollor color="green"> ["Python", "C#", "React"]</SpanCollor>
                </p>
        </div>
    );
}

export default CardProfile;